import React, { useContext } from 'react';
import { RichText } from '../../../../../hoc/components/rich-text';
import { enrollmentContext } from '../../../../../hoc/context/enrollment/enrollment-context';
import context from '../../../../../hoc/context/product/context';

const ServicesInfo: React.FC<{}> = () => {
	const ctxt = useContext(context);
	const enrollmentCtxt = useContext(enrollmentContext);

	return (
		<div>
			<h3 className="font-semibold">{ctxt.json.pages.review.subheader}</h3>
			<div className="mt-5 ml-4">
				<>
					{ctxt.json.services
						.filter((service) =>
							service.isEligible(
								enrollmentCtxt.input.performer,
								enrollmentCtxt.input.questions,
								enrollmentCtxt.input.consents,
								enrollmentCtxt.input.discardedServices
							)
						)
						.map((service, index) => (
							<li key={index}>
								<RichText html={service.shortDescription} />
							</li>
						))}
				</>
			</div>
		</div>
	);
};
export default ServicesInfo;
